/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />
/// <reference path="services/app.common.services.module.ts" />
/// <reference path="directives/app.common.directives.module.ts" />
/// <reference path="controllers/app.common.controllers.module.ts" />
/// <reference path="filters/app.common.filters.module.ts" />

((() => {
	'use strict';

	angular.module('app.common',
	[
		'app.common.controllers',
		'app.common.directives',
		'app.common.filters',
		'app.common.services'
	]);

})());